<button #btnSave (click)="saveLanding()" id="btnSave" type="button" class="btn btn-outline-primary btn-save btn-spinning">Save</button>